import { render, staticRenderFns } from "./payIndex.vue?vue&type=template&id=4e6a6072&scoped=true"
import script from "./payIndex.vue?vue&type=script&lang=js"
export * from "./payIndex.vue?vue&type=script&lang=js"
import style0 from "./payIndex.vue?vue&type=style&index=0&id=4e6a6072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6a6072",
  null
  
)

export default component.exports